
export const TYPE = {
  GET_PRODUCTS: "GET_PRODUCTS",
  GET_CATEGORIES: "GET_CATEGORIES",
  SEARCH_FILTER: "SEARCH_FILTER",
  PRICE_FILTER: "PRICE_FILTER",
  CATEGORY_FILTER: "CATEGORY_FILTER",
  ADD_CATEGORY_FILTER: "ADD_CATEGORY_FILTER",
  RATING_FILTER: "RATING_FILTER",
  SORT_BY_PRICE: "SORT_BY_PRICE",
  CLEAR_FILTER: "CLEAR_FILTER",
  ADD_TO_CART: "ADD_TO_CART",
  UPDATE_PRODUCT_QTY: "UPDATE_PRODUCT_QTY",
  ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  REMOVE_FROM_WISHLIST: "REMOVE_FROM_WISHLIST",
  ADD_ADDRESS: "ADD_ADDRESS",
  EDIT_ADDRESS: "EDIT_ADDRESS",
  DELETE_ADDRESS: "DELETE_ADDRESS",
  CLEAR_CART: "CLEAR_CART",
  CLEAR_WISHLIST: "CLEAR_WISHLIST",
};

export const ToastType = {
  Warn: 'warn',
  Info: 'info',
  Success: 'success',
  Error: 'error',
};

